(function ($, Cobalt, undefined) {
    Cobalt.Favorites = {
        dependentScripts: function () {
            return [{ dependency: Cobalt.User, name: "Cobalt.User"}];
        },
        initialize: function () {
            var ButtonClicked = false;
            $("body").delegate(".add-favorite", "click", function (e) {
                e.preventDefault();

                var link = $(this);
                var favoriteURL = link.attr("data-favorite-url");

                if (!ButtonClicked) {
                    ButtonClicked = true;
                    Cobalt.Core.withRequestVerificationToken(function (requestVerificationToken) {
                        Cobalt.Favorites.favoritePost(link, favoriteURL, requestVerificationToken, true);
                        ButtonClicked = false;
                    });
                            
                }
            });

            $("body").delegate(".delete-favorite", "click", function (e) {
                e.preventDefault();

                var link = $(this);
                var favoriteURL = link.attr("data-unfavorite-url");
                var token = $.cookie("RequestVerificationToken");
                Cobalt.Core.withRequestVerificationToken(function (requestVerificationToken) {
                    Cobalt.Favorites.favoritePost(link, favoriteURL, requestVerificationToken, false);
                });
            });
        },
        favoritePost: function (link, favoriteURL, requestVerificationToken, isFavorite) {
            $.ajax({
                type: "POST",
                url: favoriteURL,
                data: {"request-verification-token": requestVerificationToken},
                success: function (data) {
                    if (isFavorite) {
                        link.removeClass("add-favorite").addClass("delete-favorite");
                        link.text("Remove from Favorites"); 
                    }
                    else {
                        link.removeClass("delete-favorite").addClass("add-favorite");
                        link.text("Add to Favorites"); 
                    }
                }
            });
        }
    };
} (jQuery, Cobalt));



// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.Favorites.js